<template>
  <div class="area P3">
    <div class="d d_list">
      <div class="d bar">
        <p class="a_back"><i class="iC i_back" @click="goBack"></i></p>
        <div class="ssC">
          <input
            type="text"
            class="ss_inp"
            v-model="name"
            placeholder="可输入姓名快速查找"
          />
          <p class="ss_btn ss_btn1" @click="search"><span>查找</span></p>
        </div>
      </div>
      <comp-address
        :province="province"
        :city="city"
        :district="district"
        :provinceCode="provinceCode"
        :cityCode="cityCode"
        :districtCode="districtCode"
        :selectArea="selectArea"
        :type="'search'"
      ></comp-address>
      <select-item
        title="指定身份"
        :value="identityName"
        :list="roleList"
        :handlerSelect="selectRole"
        name="roleName"
      ></select-item>
    </div>
    <div class="d d_cy">
      <!-- <ul class="u4 u4_tit">
        <li>姓名</li>
        <li>行政区</li>
        <li >学校</li>
        <li>职务</li>
        <li>手机号</li>
        <li>性別</li>
      </ul> -->
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        class="order-list-refresh"
      >
        <van-list
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
          @offset="10"
        >
          <!-- 姓名，性别，行政区，学校（总辅导员可空白），职务（大队辅导员/总辅导员），手机号 -->
          <ul class="u u_cy">
            <li v-for="item in list" :key="item.id">
              <div class="fl">
                <h4 class="cap4">{{ item.name }}</h4>
                <p>{{ item.province }}{{ item.city }}{{ item.district }}</p>
                <p v-if="item.roleId == 6">{{ item.school }}</p>
                <p>{{ job(item.roleId) }}</p>
                <p>{{ item.tel }}</p>
                <!-- <p class="fcG2">{{ item.eduStr }}</p> -->
              </div>
              <i :class="`iC ${item.sexStr == '女' ? 'i_xb2' : 'i_xb1'}`"></i>
            </li>
          </ul>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import compAddress from "@/components/Address";
import SelectItem from "@/components/SelectItem";
import { getBook } from "@/service/form";
import { getRoleId } from "@/common/js";
export default {
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      province: "",
      provinceCode: "",
      city: "",
      cityCode: "",
      district: "",
      districtCode: "",
      school: "",
      name: "",
      identity: 0,
      size: 50,
      page: 1,
      totalPage: 1,
      list: [],
      loading: false,
      finished: false,
      finishedText: "没有更多了",
      refreshing: false,
      roleList: [],
      identityName: "",
      currentRole: -1,
    });
    onMounted(async () => {
      // 获取当前登录人的角色
      state.currentRole = await getRoleId();

      // 回显省市区
      const {
        roleList,
        province,
        provinceCode,
        city,
        cityCode,
        district,
        districtCode,
      } = store.state.info;

      if (roleList.length > 0) {
        let newList = JSON.parse(JSON.stringify(roleList));
        newList.unshift({ roleId: -1, roleName: "不限" });
        state.roleList = newList;
      }
      if (province != null) {
        state.province = province;
        state.provinceCode = provinceCode;
      }
      if (city != null) {
        state.city = city;
        state.cityCode = cityCode;
      }
      if (district != null) {
        state.district = district;
        state.districtCode = districtCode;
      }
    });
    const selectArea = (area) => {
      // if (JSON.stringify(area).indexOf("不限") != -1) {
      //   const { province = "", city = "", district = "" } = area;
      //   if (province != "" && province == "不限") {
      //     state.province = "不限";
      //     state.city = "不限";
      //     state.district = "不限";
      //   }
      //   if (city != "" && city == "不限") {
      //     state.city = "不限";
      //     state.district = "不限";
      //   }
      //   if (district != "" && district == "不限") {
      //     state.district = "不限";
      //   }
      // } else {
        // 合并
        Object.assign(state, area);
      // }
      state.page = 1;
      state.totalPage = 1;
      state.list = [];
      onLoad();
    };
    const job = (roleid) => {
      let j = "";
      switch (roleid) {
        case 1:
          j = "管理员";
          break;
        case 2:
          j = "全国少工委";
          break;
        case 3:
        case 4:
        case 5:
          j = "总辅导员";
          break;
        case 6:
          j = "大队辅导员";
          break;
      }
      return j;
    };
    const selectRole = (role) => {
      state.identity = role.roleId;
      state.identityName = role.roleName;
      state.page = 1;
      state.totalPage = 1;
      state.list = [];
      onLoad();
    };
    const goBack = () => {
      router.go(-1);
    };
    const onLoad = () => {
      if (!state.refreshing && state.page < state.totalPage) {
        state.page = state.page + 1;
      }
      if (state.refreshing) {
        state.list = [];
        state.refreshing = false;
      }
      loadData();
    };
    const loadData = async () => {
      const { province, city, district, school, name, identity, size, page } = state;
      let p = province,
        c = city,
        d = district;
      if (province == "不限") {
        p = "";
      }
      if (city == "不限") {
        c = "";
      }
      if (district == "不限") {
        d = "";
      }
      try {
        const {
          code,
          data,
          data: { list = [] },
        } = await getBook({
          province: p,
          city: c,
          district: d,
          school,
          name,
          identity,
          size,
          page,
        });
        if (code === 10000) {
          if (list) {
            state.list = state.list.concat(list);
          }
          state.totalPage = data.totalPage;
          state.loading = false;
          if (state.page >= data.totalPage) state.finished = true;
        }
      } catch (error) {
        state.loading = false;
        state.finished = true;
        state.finishedText = "服务异常，请稍后重试";
      }
    };

    const onRefresh = () => {
      state.refreshing = true;
      state.finished = false;
      state.loading = true;
      state.page = 1;
      onLoad();
    };

    const search = () => {
      state.page = 1;
      state.totalPage = 1;
      state.list = [];
      onRefresh();
    };
    return {
      ...toRefs(state),
      selectArea,
      onLoad,
      onRefresh,
      goBack,
      search,
      selectRole,
      job,
    };
  },
  components: {
    compAddress,
    SelectItem,
  },
};
</script>
<style lang="less" scoped>
.u4 {
  display: flex;
  justify-content: space-around;
}
.u4 li {
  width: auto;
}
.u_cy li:first-child {
  border-top: none;
}
</style>
